/* eslint-disable react-hooks/exhaustive-deps */
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DateRangePicker } from "rsuite";
import peticionBack from "../../../libs/peticiones/peticionBack";
import createURL from "../../../libs/peticiones/url";
import CardC from "../../../components/CustomCard/CardC";
import { ReportGroup } from "../../../enums/ReportGroup";

const defConfig = {
    options: {
        chart: { type: "donut" },
        legend: {
            position: 'bottom'
        },
        labels: [""]
      } as ApexOptions,
    series: [] as any[]
}

export default function InstanceChart(){
    const [dates, setDates] = useState<Date[]|null>(null);
    const [config, setConfig] = useState(defConfig);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        getData();
    }, [dates]); 

    async function getData() {
        let url = createURL(`/reportes/files/count_group/${ReportGroup.INSTANCES}`, [
            { name: "startDate", value: cleanDate(0)},
            { name: "endDate", value: cleanDate(1) },
        ]);
        const cpy = { ...defConfig }
        const res = await peticionBack({}, url, "GET", false);
        if(res && res.length > 0){
            const labels: string[] = [];
            const series: number[] = [];
            res.sort((a:any, b:any) => a.instance.localeCompare(b.instance)).forEach((instance: any)=>{
                labels.push(instance.instance);
                series.push(+instance.total);
            });
            cpy.options.labels = labels;
            cpy.series = series;
        }else{
            cpy.series = [];
        }
        setConfig(cpy);
        setLoading(false);
    }

    function cleanDate(pos: number){
        if(!dates) return "";
        let str = dates[pos].toISOString().split("T")[0];
        if(pos === 0) str += "T00:00:00Z";
        else  str += "T23:59:59Z";
        return str;
    }

    return(
        <CardC className="mb-4">
            <div className="d-flex flex-md-row flex-column justify-content-md-between mb-2">
                <h6>Sentencias por Instancia</h6>
                <DateRangePicker 
                    size="xs" 
                    appearance="subtle"
                    placeholder="Fechas" 
                    style={{ width: "auto" }} 
                    onChange={(e)=> setDates(e)}
                    preventOverflow
                    placement="auto"
                />
            </div>
            <div className="border" style={{minHeight: 310}}>
                {!loading && <Chart options={config.options} series={config.series} type="donut" height={350} /> }
            </div>
        </CardC>
    )
}